import { CallType } from '@weblite/ts-action/media-proxy'

export enum CallAction {
  JOIN_CALL = 'join-call',
  START_CALL = 'start-call',
  REJECT_INCOMING_CALL = 'reject-incoming-call',
  ACCEPT_INCOMING_CALL = 'accept-incoming-call',
}

export function reportCallActionFailure(
  action: CallAction,
  callType: CallType,
  timeout: number,
  additionalData?: Record<string, unknown>,
) {
  analite('CALL_ACTION_FAILED', {
    action,
    callType,
    timeout,
    ...additionalData,
  })
}
